import { CustomerSpecialRequirement } from "./enquiry.model";

export class EditEnquiry {
    dueDate?: number | null;
    optionDate?: number | null;
    projectName?: string | null;
    alloySurcharge?: boolean = true;
    applicableNorms?: string | null;
    normGradesId?: number[];
    marketingGradeId?: number | null;
    rawMaterialGrade?: string;
    testCategory?: string | null;
    od?: number | null;
    odUom?: string | null;
    orderReason?: string;
    wt?: number | null;
    wtUom?: string | null;
    id?: number | null;
    idUom?: string | null;
    npsScheduleId?: number | null;
    smsId?: number;
    totalWeight?: number;
    totalWeightUom?: string;
    remark?: string | null;
    marketFamilyId?: number;
    customerEnquiryNo?: string;
    mstOfferStatus?: string;
    length?: number;
    lengthUom?: string;
    offerValidityId?: number;
    offerValidityDate?: number | null;
    salesPersonId?: number | null;
    salesOfficeId?: number | null;
    customerSpecialRequirements?: CustomerSpecialRequirement[];
    offerSchemeCode?: string | null;
    bonusSchemeCode?: string | null;
}



